import { currencyString } from "@qgiv/core-js";

/**
 * @typedef {import("@qgiv/donation-form").ReduxTypes.FormSettings.Currency} Currency
 */

/**
 *
 * @param {number} minAmt
 * @param {number} subtotal
 * @returns {boolean}
 */
export const getHasMinAmountValidationError = (minAmt, subtotal) => {
    const hasMinAmountValidationError = subtotal < minAmt;

    return hasMinAmountValidationError;
};

/**
 *
 * @description If a donor never sets a maximum amount the maxAmt value that
 * the BE delivers to the FE is 0. This is very important because if we do not
 * account for this use case the FE will throw max validation errors for all
 * donations whenever the max amount is not set.
 * @param {number} maxAmt
 * @param {number} subtotal
 * @returns {boolean}
 */
export const getHasMaxAmountValidationError = (maxAmt, subtotal) => {
    const hasSetMaxAmount = maxAmt > 0;
    const hasMaxAmountValidationError = hasSetMaxAmount
        ? subtotal > maxAmt
        : false;

    return hasMaxAmountValidationError;
};

/**
 *
 * @param {number} minAmt
 * @param {Currency} currency
 * @returns {string}
 */
export const getMinAmountValidationError = (minAmt, currency) => {
    const formattedMinAmt = currencyString(minAmt, currency);

    return `Your donation must be at least ${formattedMinAmt}`;
};

/**
 *
 * @param {number} maxAmt
 * @param {Currency} currency
 * @returns {string}
 */
export const getMaxAmountValidationError = (maxAmt, currency) => {
    const formattedMaxAmt = currencyString(maxAmt, currency);

    return `Your donation must be less than ${formattedMaxAmt}`;
};

/**
 *
 * @param {object} options
 * @param {number} options.maxAmt
 * @param {number} options.minAmt
 * @param {number} options.subtotal
 * @returns {boolean}
 */
export const getHasMinMaxValidationError = ({ maxAmt, minAmt, subtotal }) => {
    const hasMinAmountValidationError = getHasMinAmountValidationError(
        minAmt,
        subtotal,
    );
    const hasMaxAmountValidationError = getHasMaxAmountValidationError(
        maxAmt,
        subtotal,
    );

    const hasMinMaxValidationError =
        hasMinAmountValidationError || hasMaxAmountValidationError;

    return hasMinMaxValidationError;
};
